import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-settings-01',
  standalone: true,
  templateUrl: './rt-icon-settings-01.component.html',
  styleUrls: ['./rt-icon-settings-01.component.scss']
})
export class RtIconSettings01Component {
  @Input() width: number | string = 22;
  @Input() height: number | string = 22;
}
